import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";
import {
  inputTextKind,
  matchSuggestionKind,
  filterToQueryKind,
  OptionRendererKind,
} from "../../common/OptionRendererKind";

const salesmanIncentiveFilterList = (permissions) => {
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      label="mine.label.start_date"
      variant="outlined"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      label="mine.label.end_date"
      variant="outlined"
      minDateSource="start_date"
    />,
    <ReferenceInput
      alwaysOn
      source="salesman_id"
      reference="salesmen"
      perPage={10}
      sort={{
        field: "salesmen.code",
        order: "ASC",
      }}
      filter={{ "salesmen.active": "1" }}
      // enableGetChoices={(filters) => !!filters.all}
    >
      <AutocompleteInput
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText={<OptionRendererKind />}
        inputText={inputTextKind}
        matchSuggestion={matchSuggestionKind}
        filterToQuery={filterToQueryKind}
      />
    </ReferenceInput>,
    <ReferenceArrayInput
      alwaysOn
      source="category_ids"
      reference="categories"
      perPage={20}
      sort={{ field: "categories.display_order", order: "ASC" }}
    >
      <SelectArrayInput
        variant="outlined"
        fullWidth
        optionValue="id"
        optionText={<OptionRendererKind />}
        filterToQuery={filterToQueryKind}
      />
    </ReferenceArrayInput>,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default salesmanIncentiveFilterList;
